import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MapPin, ChevronDown, UserRound, Bell } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { useAuth } from "../context/AuthContext";
import { dashPathFor } from "./GoogleAuth";
import NotificationBell from "./NotificationBell";
import api from "../lib/api";

export const MobileHeader = ({ settings }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(localStorage.getItem("mobile-city") || "");
  useEffect(() => { api.get("/institutions/cities").then(({ data }) => setCities(data.cities || [])).catch(() => {}); }, []);
  const change = (value) => {
    setCity(value); localStorage.setItem("mobile-city", value);
    navigate(value ? `/institutes?city=${encodeURIComponent(value)}` : "/institutes");
  };
  return <div className="mobile-header" data-testid="mobile-header">
    <Link to="/" data-testid="mobile-brand" aria-label={settings?.business_name || "DreamCots"} className="mobile-brand"><BrandLogo settings={settings} mobile testid="mobile-brand-logo" /></Link>
    <div className="mobile-location"><MapPin size={16} /><select aria-label="Choose city" data-testid="mobile-location-select" value={city} onChange={(e) => change(e.target.value)}><option value="">{cities[0] || "All cities"}</option>{cities.map((c) => <option key={c} value={c}>{c}</option>)}</select><ChevronDown size={13} /></div>
    <div className="mobile-header-actions">{user ? <NotificationBell idSuffix="-mobile" /> : <Link to="/login" data-testid="mobile-notifications-login" aria-label="Sign in for notifications"><Bell size={21} /></Link>}
      <Link to={dashPathFor(user)} data-testid="mobile-profile-link" aria-label="Your profile" className="mobile-avatar">{user?.picture ? <img src={user.picture} alt="" /> : <UserRound size={21} />}</Link>
    </div>
  </div>;
};
